import { InterventionCategory } from '@/types';
import { Icon, Inline, InlineItem, Select, Stack, Text } from '@kinesis/bungle';
import { LegendContainer } from './chart.styles';
import {
  renderInterventionCategory,
  interventionCategories,
} from '@/data/labels';
import { categoryColors } from '@/data/colors';

const options = [
  { value: 'current', label: 'Current settings' },
  { value: 'intermediate', label: 'Intermediate' },
  { value: 'aggressive', label: 'Aggressive' },
];
const EmissionsReductionsLegend = (props: EmissionsReductionsLegendProps) => {
  const { onChange, value } = props;
  return (
    <LegendContainer>
      <Stack space='medium'>
        <Stack space='xsmall'>
          {/*<Text>Policy context</Text>*/}
          <Select wrap onChange={onChange} value={value} options={options} />
        </Stack>
        <Stack space='xsmall'>
          {interventionCategories.map((c: InterventionCategory) => (
            <Inline space='small'>
              <InlineItem>
                <Icon
                  color={categoryColors[c]}
                  magnitude='small'
                  type='circle'
                />
              </InlineItem>
              <InlineItem>
                <Text>{renderInterventionCategory(c)}</Text>
              </InlineItem>
            </Inline>
          ))}
        </Stack>
      </Stack>
    </LegendContainer>
  );
};

export type EmissionsReductionsLegendProps = {
  onChange: (v: 'current' | 'intermediate' | 'aggressive') => void;
  value: string;
};

export { EmissionsReductionsLegend };
